export default __webpack_public_path__ + "static/media/projecttwo.cc73f797.jpg";